import { Box } from "@mui/material";
import styled from "styled-components";

export const StyledLoaderBox = styled(Box)`
  height: 204px;
  display: flex;
  align-items: center;
`;

export const Wrapper = styled.div`
  .chartWrapper {
    position: relative;
  }

  .chartWrapper > canvas {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
  }

  .chartAreaWrapper {
    overflow-x: auto;
  }
`;
